import React from "react";

import { DURATION_UNITS } from "../../../../utils/durations";
import DataTableColumnHeader from "../../../dataTable/DataTableColumnHeader";
import {
  dateTimeColumn,
  durationColumn,
  lazyActionsColumn,
} from "../../../dataTable/dataTableColumns";
import DataTableLinkCell from "../../../dataTable/DataTableLinkCell";
import { adBreakPath } from "../../../routes/routes";

import type { TFunction } from "i18next";

import type { AdBreakItem } from "../../../../api/FastAPI.types";
import type {
  DataTableColumnDef,
  RowAction,
} from "../../../dataTable/dataTable.types";

interface AdBreakColumnsOptions {
  t: TFunction;
  channelId: string;
  loadActions: (adBreak: AdBreakItem) => Promise<RowAction[]>;
}

export function getAdBreakHref(
  channelId: string,
  adBreak: AdBreakItem,
): string {
  return adBreakPath(channelId, adBreak.uuid);
}

export function adBreakColumns({
  t,
  channelId,
  loadActions,
}: AdBreakColumnsOptions): DataTableColumnDef<AdBreakItem>[] {
  return [
    {
      accessorKey: "name",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("advertisingBreakName")}
        />
      ),
      meta: {
        searchable: true,
        label: t("advertisingBreakName"),
        minWidth: 215,
      },
      cell: ({ row }) => (
        <DataTableLinkCell href={getAdBreakHref(channelId, row.original)}>
          {row.original.name}
        </DataTableLinkCell>
      ),
    },
    durationColumn<AdBreakItem>(
      "duration",
      t("breakDuration"),
      DURATION_UNITS.MILLISECONDS,
      "humanised",
      { width: "26%", minWidth: 157 },
    ),
    dateTimeColumn<AdBreakItem>("updated_at", t("update_date")),
    lazyActionsColumn<AdBreakItem>(loadActions, (adBreak) => adBreak.name),
  ];
}
